import * as olStyle from 'ol/style';
import { source } from '@pages/trucks/geofences/geofence-features-layer';
import Feature from 'ol/Feature';
import { Polygon as OlPolygon } from 'ol/geom';
import { pointsToEN } from '@openlayers/ol-utils';
import { GeofenceDraw } from '@shared/trucks/GeofenceDraw';
import { GeofenceKmlExport } from '@openlayers/tools/GeofenceKmlExport';


export enum GeofenceType { // todo, because of webpack bug we can't use ambient const enums, check later if its resolved
    UNLOAD = 0,
    LOAD = 1,
    HYBRID = 2,
    PARKING = 3,
}

const stylesStroke = {
    normal: new olStyle.Stroke({
        color: [0, 0, 0, 0.9],
        width: 2,
    }),
    dashed: new olStyle.Stroke({
        color: [0, 0, 0, 0.9],
        width: 2,
        lineDash: [10, 10],
    }),
};

const stylesFill = {
    unload: new olStyle.Fill({
        color: [240, 10, 10, 0.5],
    }),
    load: new olStyle.Fill({
        color: [20, 170, 20, 0.4],
    }),
    hybrid: new olStyle.Fill({
        color: [0, 100, 250, 0.5],
    }),
    parking: new olStyle.Fill({
        color: [100, 100, 100, 0.5],
    }),
};

export const GeofenceFeatureFactory = {
    styles: {
        normal: {
            0: new olStyle.Style({
                stroke: stylesStroke.normal,
                fill: stylesFill.unload,
            }),
            1: new olStyle.Style({
                stroke: stylesStroke.normal,
                fill: stylesFill.load,
            }),
            2: new olStyle.Style({
                stroke: stylesStroke.normal,
                fill: stylesFill.hybrid,
            }),
            3: new olStyle.Style({
                stroke: stylesStroke.normal,
                fill: stylesFill.parking,
            })
        },
        dashed: {
            0: new olStyle.Style({
                stroke: stylesStroke.dashed,
                fill: stylesFill.unload,
            }),
            1: new olStyle.Style({
                stroke: stylesStroke.dashed,
                fill: stylesFill.load,
            }),
            2: new olStyle.Style({
                stroke: stylesStroke.dashed,
                fill: stylesFill.hybrid,
            }),
            3: new olStyle.Style({
                stroke: stylesStroke.dashed,
                fill: stylesFill.parking,
            })
        },
    },

    exportAreaAsKml: (geofenceId: string | number, geofenceTitle: string, geofenceType: GeofenceType) => {
        let color: string;

        switch (geofenceType) {
            // in KML, color format is # AA BB GG RR
            case GeofenceType.UNLOAD: { color = "800a0af0"; break; }
            case GeofenceType.LOAD: { color = "6614aa14"; break; }
            case GeofenceType.HYBRID: { color = "80fa6400"; break; }
            case GeofenceType.PARKING: { color = "80646464"; break; }
        }

        GeofenceKmlExport.export(source.getFeatureById(geofenceId), geofenceTitle, color);
    },

    importAreaFromKml
}

async function importAreaFromKml(file: File, draw: GeofenceDraw): Promise<Feature<OlPolygon> | false> {
    draw.source.clear();  // clear active (drawn) polygon
    // PARSE <COORDINATES> FROM FILE
    let coordsTags;
    const re = /(<coordinates>)([\s\S]*?)(<\/coordinates)/g;
    if ((await file.text()).search(re) === -1) {
        console.log("NO COORDINATES IN FILE");
        return false;
    } else {
        coordsTags = (await file.text()).match(re);
    }
    // since Safari does not support lookbehind in regex /(?<=<coordinates>)([\s\S]*?)(?=<\/coordinates)/g
    // I changed above regex, and here removing <coordinates> tags from the string
    const coordinates = coordsTags[0]
    .substring("<coordinates>".length, coordsTags[0].length - "</coordinates".length);
    // FORMAT COORDINATES
    const coords = xmlLatLonCoordsToEN(coordinates);
    // MAKE A POLYGON
    const polyFeature = new Feature({
        geometry: new OlPolygon([coords]),
    });
    draw.source.addFeature(polyFeature);
    // ENABLE EDITING OF POLYGON
    draw.startModifyFeature(polyFeature);
    return polyFeature;
}

function xmlLatLonCoordsToEN(coords){
    // APPEND ALL COORDS TO A STRING
    let coordsString = "";
    // refine string for database format: 1 2, 3 4, 5 6
    // remove spaces, replace comma with space, replace new line with comma, remove Z coord
    coordsString += (coords.toString().trim()
    .replaceAll(" ", "")
    .replaceAll(",", " ")
    .replaceAll("\n", ",")
    .concat(",")
    .replaceAll(/([0-9])(\s*[0-9]*)(,)/g, "$1$3"));
    // .replaceAll(/(?<=[0-9])(\s*[0-9]*)(?=,)/g, ""));
    // concat comma (,) to remove very last Z-coord

    const coordsParsed = coordsString.substring(0, coordsString.length-1); // remove comma at the end
    // SPLIT COORDS STRING INTO ARRAY (OF STRINGS)
    const coordsArrays = [];
    const coordsArray = coordsParsed.split(","); // "1 2, 3 4, 5 6" -> ["1 2","3 4","5 6"]
    coordsArray.forEach((coords) => {
        coordsArrays.push(coords.split(" ")); // -> [['1', '2'],['3','4']['5','6']]
    })
    // STRING TO NUMBER
    const coordinates = coordsArrays.map(coordArray => coordArray.map(coord => +coord));
    // COORDS ARRAY INTO JSON
    const arrayJsonCoords = [];
    coordinates.forEach(coords => {
        arrayJsonCoords.push({lat: coords[1], lon: coords[0]});
    })
    // TRANSFORM TO EAST/NORTH SYSTEM
    return pointsToEN(arrayJsonCoords);
}
